// src/components/AppBar.js
import { AppBar, Divider } from "@mui/material";
import TopToolbar from "./TopToolbar";
import ProjectToolbar from "./ProjectToolbar";

const AppBarComponent = ({
  canvas,
  showRuler,
  setShowRuler,
  zoomLevel,
  zoomIn,
  zoomOut,
  isPanMode,
  setIsPanMode,
  signCategorySizeState,
  updateCanvasSize,
}) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: "100%",
        zIndex: 1200,
        backgroundColor: "white",
        color: "black",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        py: 0, // Remove padding to match exact height
      }}
    >
      <TopToolbar />
      <Divider sx={{ bgcolor: "grey.300" }} />
      <ProjectToolbar
        canvas={canvas}
        showRuler={showRuler}
        setShowRuler={setShowRuler}
        zoomLevel={zoomLevel}
        zoomIn={zoomIn}
        zoomOut={zoomOut}
        isPanMode={isPanMode}
        setIsPanMode={setIsPanMode}
        signCategorySizeState={signCategorySizeState}
        updateCanvasSize={updateCanvasSize}
      />
    </AppBar>
  );
};

export default AppBarComponent;
